import { store } from '@user/store/store'
import {
  selectLocationTypeById,
  locationTypeDisplayName,
} from '@user/store/locationTypes/slice'

export const locationTypeValueFormatter = (
  locationTypeId: string | null,
): string => {
  if (typeof locationTypeId === 'string') {
    const locType = selectLocationTypeById(store.getState(), locationTypeId)
    return !!locType ? locationTypeDisplayName(locType) : ''
  }
  return ''
}
